import { render, staticRenderFns } from "./TextareaHeight.vue?vue&type=template&id=09a7cac0&"
import script from "./TextareaHeight.vue?vue&type=script&lang=js&"
export * from "./TextareaHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports